import { Navbar } from './ui/Navbar';
import { i18n } from './core/I18nManager';

class InfoPage {
    constructor() {
        this.init();
    }

    async init() {
        await i18n.init();
        const navbarRoot = document.getElementById('navbar-root');
        if (navbarRoot) new Navbar(navbarRoot);

        const path = window.location.pathname;
        if (path.includes('about')) {
            this.renderAbout();
        } else if (path.includes('privacy')) {
            this.renderPrivacy();
        } else if (path.includes('terms')) {
            this.renderTerms();
        } else if (path.includes('contact')) {
            this.renderContact();
        }
    }

    renderContact() {
        this.setContent(
            i18n.t('contact_title'),
            `<p class="text-lg text-stone-600 mb-16 leading-relaxed">${i18n.t('contact_intro')}</p>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-24">
                <div class="p-8 bg-white border border-stone-200 rounded-2xl shadow-sm">
                    <div class="w-12 h-12 bg-stone-100 rounded-xl flex items-center justify-center text-stone-900 mb-6">
                        <iconify-icon icon="solar:letter-bold" width="24"></iconify-icon>
                    </div>
                    <h3 class="text-xl font-bold text-stone-900 mb-2">${i18n.t('contact_email_title')}</h3>
                    <p class="text-stone-500 mb-4">${i18n.t('contact_email_text')}</p>
                    <a href="mailto:support@jigsawhex.com" class="text-lg text-stone-900 font-semibold hover:underline">support@jigsawhex.com</a>
                </div>

                <div class="p-8 bg-white border border-stone-200 rounded-2xl shadow-sm">
                    <div class="w-12 h-12 bg-stone-100 rounded-xl flex items-center justify-center text-stone-900 mb-6">
                        <iconify-icon icon="solar:clock-circle-bold" width="24"></iconify-icon>
                    </div>
                    <h3 class="text-xl font-bold text-stone-900 mb-2">${i18n.t('contact_hours_title')}</h3>
                    <p class="text-stone-500 mb-4">${i18n.t('contact_hours_text')}</p>
                    <div class="flex gap-2">
                        <span class="w-2 h-2 rounded-full bg-emerald-500 mt-1.5 animate-pulse"></span>
                        <span class="text-xs text-stone-400 uppercase tracking-widest font-bold">Online Now</span>
                    </div>
                </div>
            </div>

            <div class="space-y-12">
                <h2 class="text-2xl zen-serif text-stone-900">${i18n.t('contact_faq_title')}</h2>
                
                <div class="grid grid-cols-1 gap-10">
                    <div>
                        <h4 class="text-lg font-bold text-stone-800 mb-3">${i18n.t('contact_faq_q1')}</h4>
                        <p class="text-stone-600 leading-relaxed">${i18n.t('contact_faq_a1')}</p>
                    </div>
                    <div>
                        <h4 class="text-lg font-bold text-stone-800 mb-3">${i18n.t('contact_faq_q2')}</h4>
                        <p class="text-stone-600 leading-relaxed">${i18n.t('contact_faq_a2')}</p>
                    </div>
                </div>
            </div>`
        );
    }

    renderAbout() {
        this.setContent(
            i18n.t('about_title'),
            `<p class="text-2xl font-light text-stone-800 leading-relaxed mb-16 border-l-4 border-stone-200 pl-8 italic">
                "${i18n.t('about_intro')}"
            </p>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
                <div>
                    <h2 class="flex items-center gap-3">
                        <iconify-icon icon="solar:compass-bold" class="text-stone-400" width="24"></iconify-icon>
                        ${i18n.t('about_mission_title')}
                    </h2>
                    <p class="text-stone-600">${i18n.t('about_mission_text')}</p>
                </div>
                <div>
                    <h2 class="flex items-center gap-3">
                        <iconify-icon icon="solar:hexagon-bold" class="text-stone-400" width="24"></iconify-icon>
                        ${i18n.t('about_hex_title')}
                    </h2>
                    <p class="text-stone-600">${i18n.t('about_hex_text')}</p>
                </div>
                <div class="md:col-span-2">
                    <h2 class="flex items-center gap-3">
                        <iconify-icon icon="solar:users-group-rounded-bold" class="text-stone-400" width="24"></iconify-icon>
                        ${i18n.t('about_community_title')}
                    </h2>
                    <p class="text-stone-600">${i18n.t('about_community_text')}</p>
                </div>
            </div>

            <div class="mt-24 pt-12 border-t border-stone-100">
                <div class="flex flex-col items-center text-center space-y-6">
                    <div class="w-12 h-12 border-2 border-stone-800 flex items-center justify-center rounded-sm rotate-45 mb-4">
                        <div class="w-3 h-3 bg-stone-800 rounded-full"></div>
                    </div>
                    <p class="max-w-xl text-xs text-stone-400 uppercase tracking-widest leading-loose">
                        ${i18n.t('about_footer_text')}
                    </p>
                </div>
            </div>`
        );
    }

    renderPrivacy() {
        this.setContent(
            i18n.t('privacy_title'),
            `<p class="text-lg font-medium text-stone-800 mb-8">${i18n.t('privacy_intro')}</p>
             <h2>${i18n.t('privacy_s1_title')}</h2>
             <p>${i18n.t('privacy_s1_content')}</p>
             <h2>${i18n.t('privacy_s2_title')}</h2>
             <p>${i18n.t('privacy_s2_content')}</p>
             <h2>${i18n.t('privacy_s3_title')}</h2>
             <p>${i18n.t('privacy_s3_content')}</p>
             <h2>${i18n.t('privacy_s4_title')}</h2>
             <p>${i18n.t('privacy_s4_content')}</p>
             <h2>${i18n.t('privacy_s5_title')}</h2>
             <p>${i18n.t('privacy_s5_content')}</p>
             <h2>${i18n.t('privacy_s6_title')}</h2>
             <p>${i18n.t('privacy_s6_content')}</p>`
        );
    }

    renderTerms() {
        this.setContent(
            i18n.t('terms_title'),
            `<p class="text-lg font-medium text-stone-800 mb-8">${i18n.t('terms_intro')}</p>
             <h2>${i18n.t('terms_basic_title')}</h2>
             <p>${i18n.t('terms_basic_content')}</p>
             <h2>${i18n.t('terms_content_title')}</h2>
             <p>${i18n.t('terms_content_content')}</p>
             <h2>${i18n.t('terms_general_title')}</h2>
             <p>${i18n.t('terms_general_content')}</p>
             <h2>${i18n.t('terms_license_title')}</h2>
             <p>${i18n.t('terms_license_content')}</p>`
        );
    }

    setContent(title: string, html: string) {
        const titleEl = document.getElementById('page-title');
        const contentEl = document.getElementById('page-content');
        if (titleEl) titleEl.textContent = title;
        if (contentEl) contentEl.innerHTML = html;
        document.title = `${title} - Jigsaw Hex`;
    }
}

new InfoPage();
